import { NotifyHelper } from "../../../helpers/toast";
import { objDotDangKyAnDefine } from "../../action-types/thuc-don/IFoDotDangKyAnActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const foDotDangKyAnActions = {
    ...generateActions(objDotDangKyAnDefine, "DOT_DANG_KY_AN"),
    ...generateActionForKey(objDotDangKyAnDefine, "DOT_DANG_KY_AN",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDotDangKyAnDefine, "DOT_DANG_KY_AN",
        "SAVE_SUCCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objDotDangKyAnDefine, "DOT_DANG_KY_AN",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDotDangKyAnDefine, "DOT_DANG_KY_AN",
        "DELETE_SUCCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objDotDangKyAnDefine, "DOT_DANG_KY_AN",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
};
